import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { AppContext } from '@prisjakt/ui-app-context';
import { SingleRange } from '@prisjakt/ui-filters';
import { useHistory } from 'react-router-dom';

import Chip from '../../../../components/chip';
import VisibilityToggle from '../../../category/components/sub-category-listing/components/toggle'; // TODO: Move this to some common area
import * as S from './styles';

const Facet = ({
  facet,
  currentSelection,
  maxListItems,
  showMoreButton,
  onToggleFacet,
  onToggleLimit,
  link,
}) => {
  const { t, linkTo } = useContext(AppContext);
  const { push } = useHistory();

  switch (facet.type) {
    case 'SearchFacetList': {
      const selected = currentSelection.selected || [];
      const sliced = facet.buckets.slice(0, maxListItems || Infinity);

      return (
        <>
          {sliced.map(item => (
            <Chip
              key={item.id}
              selected={selected.indexOf(item.id) !== -1}
              onClick={() => {
                if (link) {
                  const url = linkTo(link, item);
                  if (url) {
                    push(url);
                  }
                  return;
                }

                onToggleFacet(facet.id, facet.type, item.id);
              }}
            >
              <S.FacetItem>
                {item.name} ({item.count})
              </S.FacetItem>
            </Chip>
          ))}

          {showMoreButton && facet.buckets.length > maxListItems && (
            <VisibilityToggle
              styling="small"
              chip
              onToggle={() => {
                onToggleLimit(facet.id, facet.type);
              }}
              label={
                facet.buckets.length !== sliced.length
                  ? t('category', 'subcategories.show-more')
                  : t('category', 'subcategories.show-less')
              }
            />
          )}
        </>
      );
    }
    case 'SearchFacetInterval': {
      const max = facet.maxCount;

      const selected =
        currentSelection.from && currentSelection.to
          ? { from: currentSelection.from, to: currentSelection.to }
          : undefined;

      return (
        <SingleRange
          showBars={facet.interval.length > 1}
          onChange={val => {
            onToggleFacet(
              facet.id,
              facet.type,
              val.value || { from: undefined, to: undefined }
            );
          }}
          type="integer"
          selected={selected}
          values={{
            min_value: facet.min,
            max_value: facet.max,
            max_matching_products: max,
            values: facet.interval.map(i => ({
              from: i.from,
              to: i.to,
              products: i.count,
            })),
          }}
        />
      );
    }
    default: {
      return null;
    }
  }
};

const { object, func } = PropTypes;

Facet.propTypes = {
  currentSelection: object,
  limits: object,
  onToggleFacet: func.isRequired,
  onToggleLimit: func.isRequired,
};

Facet.defaultProps = {
  filters: {},
  limits: {},
};

export default memo(Facet);
